import get from 'lodash/get';
import find from 'lodash/find';

export const getContainer = (state) => {
  return get(state, 'configurator.configuration.customdata.baseContainer', {});
};

export const getSelectedFloor = (state) => {
  return get(state, 'configurator.selectedFloor', 0);
};
